<!-- <div id="compliance-content-container"> -->
<div class="row">
  <div class="col-sm-12">
    <div class="container-white">
      <div class="ui-progress-status-bar" *ngIf="dontShowSummary">
        <ol>
          <!-- <li class="complete">
                <span class="stepnum">1</span>
                AdoptionAgreement Restatement
              </li> -->
          <li class="">
            <span class="stepnum">1</span>
            Select Subgroups
          </li>
          <li class="current">
            <span class="stepnum">2</span>
            Review & Complete
          </li>
        </ol>
      </div>
      <br />

      <div *ngIf="aaSelected">
        <span [hidden]="dontShowSummary">
          <p><b>Successfully approved {{aaSelected.length}} Adoption Agreement(s) and 0 Addendum(s).</b>
        </span>
      </div>

      <div *ngIf="showConfirmMessage">
        <div *ngIf="aaSelected">
          
          <section *ngIf="alert">
            <div class="row">
              <div class="col-xs-12">
                <div class="ui-alert ui-alert-info">
                  <div class="alert-content">
                    <strong>{{ alert.caption }}</strong>
                    <span *ngIf="alert.caption">&nbsp;</span>
                    <span *ngIf="alert.text" [innerHTML]="alert.text"></span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <b>Total {{aaSelected.length}} Adoption Agreement(s) and 0 Addendum(s) for Approval: </b>
          <br />
          <br />
          <ul>
            <li *ngFor="let selected of aaSelected">
              {{selected.PlanDocument}}
            </li>
          </ul>
          <br />
          <button (click)="navigateBack()" class="btn btn-primary">Back</button>&nbsp;&nbsp;
          <button (click)="submitRestatements()" class="btn btn-primary">Confirm</button>
        </div>
      </div>
    </div>
    <br />
  </div>


  <!-- </div> -->